import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useTranslation } from 'react-i18next';
import { ILaboratory } from '../types';
interface LaboratoryFormParams {
  laboratory: ILaboratory;
  onSubmit: any;
  disableEdit?: boolean;
}
function LaboratoryForm(params: LaboratoryFormParams) {
  const { t } = useTranslation();

  const { laboratory, onSubmit, disableEdit } = params;

  return (
    <div>
      {laboratory && (
        <>
          <EnhancedForm
            onSubmit={disableEdit ? {} : onSubmit}
            edit={!!laboratory.id}
            disableEdit={disableEdit}
            autoStyleLayout
            columns={2}>
            <IdentityField
              name="code"
              initialValue={laboratory.code}
              component={TextFieldAdapter}
              label={t('global.code')}
              type="text"
              validate={required}
              disabled={disableEdit}
            />

            <IdentityField
              name="description"
              initialValue={laboratory.description}
              component={TextFieldAdapter}
              label={t('global.description')}
              type="text"
              validate={required}
              disabled={disableEdit}
            />
          </EnhancedForm>
        </>
      )}
    </div>
  );
}

export default LaboratoryForm;
